<template>
	<div style="display: block; overflow: hidden; margin: 10px 0;">

		<div class="col-md-2">
			<img :src="'static/images/products/' + item.code + '.jpg'" :alt="item.name" style="width: 100%; height: auto;">
		</div>

		<div class="col-md-3">
			<p class="text-justify">{{ item.name }}</p>
		</div>

		<div class="col-md-2 text-center">

			<button v-on:click="minq">-</button>
			<button style="
			background: transparent; 
			border: 2px solid #ccc;" 
			disabled>{{ counter }}</button>
			<button v-on:click="addq">+</button>

		</div>

		<div class="col-md-3 text-right">
			Php {{ formatMoney(iteminfo.total) }}
		</div>

		<div class="col-md-2 text-right">
			<button @click="removeitem" type="button" title="removeitem" >Remove Item</button>
		</div>
		
	</div>
</template>
<script>
	export default{
		props: ['item'],
		data(){
			return{
				counter: 1
			}
		},
		computed:{
			totalPrice: function(){
				return parseFloat(this.item.price) * this.counter;
			},
			iteminfo: function(){
				return {
					code: this.item.code,
					price: this.item.price,
					quantity: this.counter,
					total: this.totalPrice
				}
			}
		},
		methods: {

			formatMoney: formatMoney,

			addq: function(event){
				this.counter++;
				this.$emit('increment', this.iteminfo);
			},
			minq: function(event){
				if(this.counter <= 1){

				}else{
					this.counter--;
					this.$emit('decrement', this.iteminfo);
				}
			},
			removeitem: function(event){
				this.$emit('removeitem', this.iteminfo);
			}
		},
		created(){
			this.$emit('additem', this.iteminfo);
		}
	}
</script>


// WEBPACK FOOTER //
// Item.vue?6fa8bea7